export default __webpack_public_path__ + "static/media/fractionSubtraction.be00c5a9.svg";